module.exports = __webpack_public_path__ + "Icono_CXProgramada_512px.png";